// Check app/views/classroom/home/index.html.erb
// https://www.chargebee.com/tutorials/stripe-embedded-checkout-form-example.html
// Calling Stripe Js to display pop up
export const openStripeCheckout = (config: {
    name?: string,
    description?: string,
    amount?: number,
    email?: string,
    token: Function
}) => {
    (window as any).EdbaseStripeHandler.open(config)
}